import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a53b0362cc250001481a3e0_1785691738159_16a2caf1/muyuride_1783869494387/src/app/accepted-bid-details/page.tsx");
